import HTTP from "@/_helpers/http";
import { PROFILE__API } from "@/_helpers/urls";
import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  account_summary: null,
  performance_overview: null,
  trading_summary: null,
  trader_performance: null,
  dashboard_banners: [],
};

const getters = {};

const mutations = {
  [PROFILE__MUTATIONS.ACCOUNTSUMMARY](state, data) {
    state.account_summary = data;
  },
  [PROFILE__MUTATIONS.PROFITLOSS](state, data) {
    state.profit_loss = data;
  },
  [PROFILE__MUTATIONS.DASHBOARDPERFORMANCE](state, data) {
    state.performance_overview = data;
  },
  [PROFILE__MUTATIONS.DASHBOARDTRADINGSUMMARY](state, data) {
    state.trading_summary = data;
  },
  [PROFILE__MUTATIONS.DASHBOARDTRADERPERFORMANCE](state, data) {
    state.trader_performance = data;
  },
  [PROFILE__MUTATIONS.DASHBOARDBANNERS](state, data) {
    state.dashboard_banners = Array.isArray(data.banners) ? data.banners : [];
  },
};

const actions = {
  async [PROFILE__ACTIONS.ACCOUNTSUMMARY]({ commit }, { trackProgress = true } = {}) {
    try {
      const response = await HTTP({
        trackProgress: trackProgress,
        loadingText: 'Processing...'
      }).get(PROFILE__API.ACCOUNTSUMMARY);
      commit(PROFILE__MUTATIONS.ACCOUNTSUMMARY, response.data);
    } catch (error) {
      console.log(error);
    }
  },
   async [PROFILE__ACTIONS.PROFITLOSS]({ commit }) {
    try {
      const response = await HTTP({trackProgress: true, loadingText: 'Processing...'}).get(PROFILE__API.PROFITLOSS);
      commit(PROFILE__MUTATIONS.PROFITLOSS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [PROFILE__ACTIONS.DASHBOARDPERFORMANCE]({ commit }, period = "month") {
    try {
      const response = await HTTP().get(PROFILE__API.DASHBOARDPERFORMANCE, {
        params: { period },
      });
      commit(PROFILE__MUTATIONS.DASHBOARDPERFORMANCE, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [PROFILE__ACTIONS.DASHBOARDTRADINGSUMMARY]({ commit }, period = "month") {
    try {
      const response = await HTTP().get(PROFILE__API.DASHBOARDTRADINGSUMMARY, {
        params: { period },
      });
      commit(PROFILE__MUTATIONS.DASHBOARDTRADINGSUMMARY, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [PROFILE__ACTIONS.DASHBOARDTRADERPERFORMANCE]({ commit }, period = "month") {
    try {
      const response = await HTTP().get(PROFILE__API.DASHBOARDTRADERPERFORMANCE, {
        params: { period },
      });
      commit(PROFILE__MUTATIONS.DASHBOARDTRADERPERFORMANCE, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [PROFILE__ACTIONS.DASHBOARDBANNERS]({ commit }) {
    try {
      const response = await HTTP().get(PROFILE__API.DASHBOARDBANNERS);
      commit(PROFILE__MUTATIONS.DASHBOARDBANNERS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};
